import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
import { Navigate } from "react-router-dom";

/** Always redirect to Preferences — sidebar drawer handles navigation on mobile */
export default function SettingsIndex() {
	useDocumentTitle("Settings");
	return <Navigate to="/settings/preferences" replace />;
}
